import type { EntrySelectorComponent, Attributes } from './initializer'

import { reinitialize } from '@/vendor/packages'

import { HclSelectAccessible } from 'hcl'
import { HclWrapper } from 'hcl'
import { HclVersion } from 'hcl'

/*
 * Add HCL Select Accessible to Vue 3 Initializer
 */
addEventListener('DOMContentLoaded', () => {

  window.Esearcher.vue3initializer.addEntrySelectorComponent(
    'select-accessible:not([data-v-app])',
    HclSelectAccessible,
    'static'
  )

})

/*
 * Add HCL Wrapper to Vue 3 Initializer
 */
// @ts-ignore
const debugWrapper = (__WEBPACK_MODE__ || 'production') === 'development'

const unwrap = (s: string) => {

  let result = ""

  try {
    result = JSON.stringify(JSON.parse(atob(s)), null, 2)
  } catch (e) {
  }

  return result

}

const wrapperDebugOutput = (version: string, defstr: string, datstr: string, stastr: string) => {

  const wl = `%c HCL ${version} %c Wrapper %c`

  console.group(
    wl,
    'background:#e52713; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff',
    'background:black; padding: 1px; border-radius: 0 3px 3px 0;  color: #fff',
    'background:transparent',
  )
  console.groupCollapsed("defstr")
  console.log(unwrap(defstr))
  console.groupEnd()
  console.groupCollapsed("datstr")
  console.log(unwrap(datstr))
  console.groupEnd()
  console.groupCollapsed("stastr")
  console.log(unwrap(stastr))
  console.groupEnd()
  console.groupEnd()

}

addEventListener('DOMContentLoaded', () => {

  window.Esearcher.vue3initializer.addEntrySelectorComponent(
    'hcl-wrapper:not([data-v-app])',
    HclWrapper,
    'static',
    undefined,
    (entry: EntrySelectorComponent) => {
      reinitialize('.hcl-wrapper')
    },
    (entry: EntrySelectorComponent, element: Element, attributes: Attributes) => {

      if (!debugWrapper) return

      wrapperDebugOutput(
        HclVersion.version,
        attributes.defstr ?? '',
        attributes.datstr ?? '',
        attributes.stastr ?? ''
      )

    },
    undefined
  )

})
